import { createRoot } from "react-dom/client";
import { Buffer } from "buffer";
import App from "./App.tsx";
import "./index.css";
import { registerServiceWorker } from "./lib/service-worker-registration";
import * as Sentry from "@sentry/react";

globalThis.Buffer ??= Buffer;

registerServiceWorker();

Sentry.init({
  dsn: "https://8db92733ed9180c830518471bd6e3e33@o4511422674567168.ingest.de.sentry.io/4511422704648272",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

createRoot(document.getElementById("root")!).render(<App />);
